/**************************************************************************************************
 *
 *  This is the main container for all reference-document related views: Project Detail (hierarch), Project
 *  Edit/Creation, Build Edit/Creation, Task Detail, Field Task Detail
 *
 *  This views are individual components that will fit into the detail-container parent element
 *  defined in this container.
 *
**************************************************************************************************/

import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import dataModel from '../../../models/DataModel';
import DirectoryFilterPopout from './DirectoryFilterPopout';
import CollectionDataSource from '../../../dao/DataSource/CollectionDataSource';
import './DirectorySearchFilter.scss';
import Input from '../../../components/Input';

// Change ReferenceDocumentSearchFilter to the appropriate name
class DirectorySearchFilter extends BaseComponent {

  constructor(props) {
    
    super(props);
    this.state = {
      search: this.props.searchString,
    };
  }

  handleUpdateMarkets(markets) {
    this.setState({ markets: markets });
  }

  handleUpdateCompanies(companies) {
    let companieslist={};
    let companiesvendor={};
    if (companies.companies){
     
      companies.companies.map(x=>{
        if(x.vendor_companies){
          x.vendor_companies.map(vendor=>{
            if (vendor.name){
              companiesvendor=companies.companies.concat(x.vendor_companies);
            }else{
              companiesvendor=companies.companies;
            }  
            return companiesvendor;
          });
        }
        return companiesvendor;
      });
    
    }
    companieslist=companiesvendor;
    this.setState({ companies: companieslist });
  }

  componentDidMount() {
    super.componentDidMount();
    this.marketsDataSource = new CollectionDataSource('MarketsCollection', 'Market', { markets: {} }, this.handleUpdateMarkets);
    this.marketsDataSource.current();
    this.companiesDataSource = new CollectionDataSource('CompaniesCollection', 'Company', { companies: {} }, this.handleUpdateCompanies);
    this.companiesDataSource.current();
  
    this.companiesDataSource.current();
    
  }

  componentWillUnmount() {
    if (this.marketsDataSource) {
      this.marketsDataSource.release();
      this.marketsDataSource = null;
    }
    if (this.companiesDataSource) {
      this.companiesDataSource.release();
      this.companiesDataSource = null;
    }
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      this.handleAddProject();
    }
    else if (e.keyCode == 27) {
      this.handleCancel();
    }
  }

  handleFilterClick() {
    this.setState({ showFilterPopout: true });
  }

  handlePopoutClose() {
    this.setState({ showFilterPopout: false });
  }

  handleSearchChange(e) {

    this.setState({ search: e.target.value });
    if (this.props.handleSearchChange) {
      this.props.handleSearchChange(e.target.value);
    }
  }

  handleApplyFilter(filter) {
    if (filter && (filter.market || filter.company || filter.permission)) {
      if (this.props.handleFilterChange) {
        this.props.handleFilterChange(filter);
      }
    }
    else {
      this.handleFilterClear();
    }
  }

  handleFilterClear() {
    this.handlePopoutClose();
    if (this.props.handleFilterChange) {
      this.props.handleFilterChange(null);
    }
  }

  render() {
    let filterPopout = null;
    if (this.state.showFilterPopout) {
      filterPopout = <DirectoryFilterPopout
        top={141}
        right={89}
        displayFontStyle={{ fontSize: '12px', fontFamily: 'Open Sans', color: '#000000', lineHeight: '32px' }}
        handleCancel={this.handlePopoutClose}
        handleClear={this.handleFilterClear}
        handleApplyFilter={this.handleApplyFilter}
        selectedFilters={this.props.selectedFilters}
        markets={this.state.markets}
        search={this.state.search}
        companies={this.state.companies}
      />;
    }
    let filterApplied = null;
   
    if (this.props.selectedFilters && this.props.selectedFilters!=null) {
      const  { market,company,permission } = this.props.selectedFilters;
      if (market.length> 0 || company.length > 0 || permission.length > 0) {
        filterApplied = <div className="filter-applied"></div>;
      }    
    }
    let classes = '';
    if (this.props.locationsProjects) {
      classes += ' locations-reference-documents';
    }
    if (this.props.adjustBottom) {
      classes += ' adjust-bottom-margin';
    }
    return (
      <div className={'directory-search-box' + classes}>

        <Input className='directory-search-input' type="text" value={this.state.search} placeholder={'Search Users'} onChange={this.handleSearchChange} />
        <div className="search-icon" />
        <div className='filter-box' onClick={this.handleFilterClick}>
          <div className="filter-icon" ref={element => { this.filterRoot = element; }} />
          {filterApplied}
        </div>
        {filterPopout}
      </div>
    );
  }
}

// Change to appropriate class name
DirectorySearchFilter.contextTypes = {
};

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    referenceDocumentsDataModel: dataModel.referenceDocumentsDataModel,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
    activitiesList: state.activityLogs.activitiesList,
  };
};

export default connect(mapStateToProps)(DirectorySearchFilter);



// WEBPACK FOOTER //
// ./src/containers/Directory/DirectorySearchFilter/index.js